import { configureStore } from '@reduxjs/toolkit';
import searchReducer from './slices/searchSlice';
import favoritesReducer from './slices/favoritesSlice';
import cartReducer from './slices/cartSlice';
import profileReducer from './slices/profileSlice';
import registrationReducer from './slices/registrationSlice';
import loginReducer from './slices/loginSlice';
import modalReducer from './slices/modalSlice';
import authReducer from './slices/authSlice';
import orderReducer from './slices/orderSlice';

export const store = configureStore({
  reducer: {
    search: searchReducer,
    favorites: favoritesReducer,
    cart: cartReducer,
    profile: profileReducer,
    registration: registrationReducer,
    login: loginReducer,
    modal: modalReducer,
    auth: authReducer,
    order: orderReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;